import React from 'react'
import { WhiteBox } from '@/components/Layout'
import Icon from '@/components/Icon'
import Resx from '@/components/Resx'
import { DataLoader } from '@/components/dataLoader'
import { Scrollbar } from '@/components/scrollbar'
import LoadingIndicator from '@/components/LoadingIndicator'

class WidgetComponent extends React.Component {
  // to be overriden
  componentKey () { return null }
  headerButtons () { return null }
  widgetIcon () { return null }
  widgetTitleKey () { return '' }
  dataSource () { return null }
  noDataSource () { return false }
  renderContent (data) { throw new Error('renderContent(data) implementation is missing!') }
  render () {
    const icon = this.widgetIcon()
    return (
      <WhiteBox className='dashboard-item'
        header={
          <React.Fragment>
            {icon && <Icon name={icon} />}
            <span><Resx name={this.widgetTitleKey()} /></span>
          </React.Fragment>
        }
        buttons={this.headerButtons()}>
        <div className='dashboard-item__body'>{this.renderBody()}</div>
      </WhiteBox>
    )
  }

  constructor (props) {
    super(props)
    this.dataSource = this.dataSource.bind(this)
  }

  renderBody () {
    if (this.noDataSource()) { return this.renderContent() }
    return (
      <DataLoader key={this.componentKey()} dataSource={this.dataSource}
        render={({ data, loading }) => (
          <div>
            {loading
              ? <LoadingIndicator />
              : <Scrollbar>{this.renderContent(data)}</Scrollbar>
            }
          </div>
        )}
      />
    )
  }
  _prepareDataSourceRequest = (widgetItem) => ({ skip: 0, take: Math.max(widgetItem.rowsCount, 1) })
}

export default WidgetComponent



// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/widgetComponent.js